<template>
  <div class="quick-menu-container is-lms is-mob">
    <div class="quick-menu">
      <!-- 교직원집합연수 -->
      <div class="staff-menu">
        <div class="caption-item" @click="goTraining">
          <div class="caption__header">
              <span class="inner-tit">
                교직원 <br class="set-media-640">
                집합연수
              </span>
          </div>
        </div>
      </div>

      <!-- 블렌디드러닝연수시스템 -->
      <div class="contact-menu">
        <div class="caption-item" @click="goContact">
          <div class="caption__header">
              <span class="inner-tit">
                블렌디드러닝 <br>
                연수시스템
              </span>
          </div>
        </div>
      </div>

      <!-- 원격교육연수 -->
      <div class="ontact-menu">
        <div class="caption-item" @click="goOntact">
          <div class="caption__header">
              <span class="inner-tit">
                원격 <br class="set-media-640">
                교육연수
              </span>
          </div>
        </div>
      </div>

      <!-- 과학정보교육 -->
      <div class="science-menu" >
        <div class="caption-item" @click="goToScienceEdu">
          <div class="caption__header">
              <span class="inner-tit">
                과학정보교육
              </span>
          </div>
        </div>
      </div>

      <!-- 정보영재교육 -->
      <div class="information-menu">
        <div class="caption-item" @click="goToCenterGenius">
          <div class="caption__header">
              <span class="inner-tit">
                정보영재교육
              </span>
          </div>
        </div>
      </div>

      <!-- 교육서비스 -->
      <div class="service-menu">
        <div class="caption-item" @click="goToElearning">
          <div class="caption__header">
              <span class="inner-tit">
                교육서비스
              </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const URL_LMS = process.env.SYSTEM.LMS.URL;

export default {
  data(){
    return{

    }
  },
  methods:{
   	// 교직원집합연수(Contact) 바로가기
    goContact(){
        window.open( URL_LMS + "/lms/sso/sso_loginWithType?type=CM")
    },
    // 원격연수(Ontact) 바로가기
    goOntact(){
        window.open( URL_LMS + "/lms/sso/sso_loginWithType?type=OM")
    },

    goToScienceEdu(){
      let query = {
        menuOid : this.$constant.MENU_OID.SCIENCE_EDU,
        boardOid : this.$constant.MENU_OID.SCIENCE_EDU,
      }

      this.$router.push({
        path : '/portal/user/common/commonBoard_list',
        query : query,
      });

    },

    goToCenterGenius() {
      this.$router.push( this.$constant.MENU_URL.CENTER_GENIUS );
    },

    goTraining(){
      this.$router.push({path : '/portal/user/common/commonScreen?menuOid=1TRvaqvX01E',});
    },

    goToElearning() {
      window.open( "https://cls.edunet.net/" );
    },
  },

}
</script>
<style scoped>
</style>
